'use client';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const SaveHistory = () => {
  const pathname = usePathname();

  useEffect(() => {
    const historyString = localStorage.getItem('history');

    if (!historyString)
      return localStorage.setItem('history', JSON.stringify([pathname]));
    const history = JSON.parse(historyString);
    const previousRoute = (history as Array<string>).pop();

    localStorage.setItem('history', JSON.stringify([previousRoute, pathname]));
  }, [pathname]);

  return null;
};

export const getHistory = (): Array<string> | undefined => {
  const historyString = localStorage.getItem('history');
  if (!historyString) return;

  const history = JSON.parse(historyString);
  return history;
};

export default SaveHistory;
